import { defineMessage, MessageDescriptor } from 'react-intl'

export const ACCESS_DENIED = 'access_denied'

export const REGISTERED = 'registered'

export const GENERIC = 'generic'

export const INVALID_PAYMENT_ERROR: MessageDescriptor = defineMessage({
  defaultMessage: 'An error occurred in submitting your payment. Please try again.',
  description: 'Error message when payment submission fails',
})
